import {inject, Injectable} from '@angular/core';
import {BaseApiService} from './base-api.service';
import {map} from 'rxjs';
import {AppStore} from '../store/app.store';
import {IVehicleFitment} from '../../types/IVehicleFitment';
import {IAlternateVehicleFitment} from '../../types/IAlternateVehicleFitment';

@Injectable({
  providedIn: 'root'
})
export class LookupVehicleService extends BaseApiService {
  private appStore = inject(AppStore);

  getMakes(year: string) {
    return this.get<{data: string[]}>(`clients/${this.appStore.client_id()}/fitments/years/${year}/makes`).pipe(
      map(response => response.data)
    );
  }

  getModels(year: string, make: string) {
    return this.get<{data: string[]}>(`clients/${this.appStore.client_id()}/fitments/years/${year}/makes/${make}/models`).pipe(
      map(response => response.data)
    );
  }

  getSubmodels(year: string, make: string, model: string) {
    return this.get<{data: string[]}>(`clients/${this.appStore.client_id()}/fitments/years/${year}/makes/${make}/models/${model}/submodels`).pipe(
      map(response => response.data)
    );
  }

  getFitments(year: string, make: string, model: string, submodel: string) {
    return this.post<{ data: any[] }>(`clients/${this.appStore.client_id()}/fitments`, { year, make, model, submodel }).pipe(
      map(response => response.data)
    );
  }

  getAlternateFitments(chassis_id: number) {
    return this.get<{ data: IAlternateVehicleFitment[] }>(`clients/${this.appStore.client_id()}/fitments/alternate?fg_chassis_id=${chassis_id}`).pipe(
      map(response => response.data)
    );
  }
}
